import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a455618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = ["src"]

import NuxtLogo from "@/assets/logos/Nuxt_Logo.svg";
import Wave from "@/assets/Wave.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "logo",
          src: _unref(NuxtLogo),
          alt: "logo"
        }, null, 8, _hoisted_3),
        _createVNode(_component_router_link, {
          to: "/",
          class: "title"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Dr. Vue.js")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, { to: "/posts" }, {
          default: _withCtx(() => [
            _createTextVNode("Posts")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, { to: "/repos" }, {
          default: _withCtx(() => [
            _createTextVNode("Repos")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("img", {
      class: "wave",
      src: _unref(Wave),
      alt: "wave"
    }, null, 8, _hoisted_5),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          name: route.meta.transition || 'fade',
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    })
  ]))
}
}

})